module.exports = __webpack_public_path__ + "static/img/hi.e23b7f8a.png";